import { Action } from '@ngrx/store';
import {
	EditFitting,
	EditFolder,
	EditHearingProtectionType,
	EditInsulationType,
	EditIsoNotVerifiedReason,
	EditStatus,
	EditTeam,
	EditVendor,
	NewFitting,
	NewFolder,
	NewHearingProtectionType,
	NewInsulationType,
	NewIsoNotVerifiedReason,
	NewStatus,
	NewTeam,
	NewVendor,
} from '../../site-settings.interfaces';
import {
	Site,
	Vendor,
	Team,
	Folder,
	InsulationType,
	IsolationNotVerifiedReason,
	HearingProtectionType,
	OrificeSize,
	LeakFormDetails,
	SteamCost,
	EditSteamCost,
	SiteName,
	Fitting,
	LeakStatus,
} from '../../site.interfaces';

export enum SiteActionTypes {
	GetSite = '[Site] Get Site',
	GetSiteSuccess = '[Site] Site Retrieved',
	GetSiteFailure = '[Site] Site Failed to Retrieve',
	GetSiteNames = '[Site] Get Site Names',
	GetSiteNamesSuccess = '[Site] Site Names Retrieved',
	GetSiteNamesFailure = '[Site] Site Names Failed to Retrieve',
	GetLeakFormDetailsForSite = '[Site] Get Leak Form Details For Site',
	GetLeakFormDetailsForSiteSuccess = '[Site] Get Leak Form Details For SiteSuccess',
	GetLeakFormDetailsForSiteFailure = '[Site] Get Leak Form Details For Site Failure',
	GetSteamCosts = '[Site] Get Steam Cost',
	GetSteamCostsSuccess = '[Site] Get Stean Cost Success',
	GetSteamCostsFailure = '[Site] Get Steam Cost Failure',
	UpdateSteamCosts = '[Site] Update Steam Costs',
	UpdateSteamCostsSuccess = '[Site] Update Steam Costs Success',
	UpdateSteamCostsFailure = '[Site] Update Steam Costs Failure',
	ClearSite = '[Site] Clear Site',
	AddFitting = '[Site] Add New Fitting',
	AddFittingSuccess = '[Site] Add New Fitting Success',
	AddFittingFailure = '[Site] Add New Fitting Failure',
	UpdateFitting = '[Site] Update Fitting',
	UpdateFittingSuccess = '[Site] Update Fitting Success',
	UpdateFittingFailure = '[Site] Update Fitting Failure',
	DeleteFitting = '[Site] Delete Fitting',
	DeleteFittingSuccess = '[Site] Delete Fitting Success',
	DeleteFittingFailure = '[Site] Delete Fitting Failure',
	AddFolder = '[Site] Add New Folder',
	AddFolderSuccess = '[Site] Add New Folder Success',
	AddFolderFailure = '[Site] Add New Folder Failure',
	UpdateFolder = '[Site] Update Folder',
	UpdateFolderSuccess = '[Site] Update Folder Success',
	UpdateFolderFailure = '[Site] Update Folder Failure',
	DeleteFolder = '[Site] Delete Folder',
	DeleteFolderSuccess = '[Site] Delete Folder Success',
	DeleteFolderFailure = '[Site] Delete Folder Failure',
	AddHearingProtectionType = '[Site] Add New HearingProtectionType',
	AddHearingProtectionTypeSuccess = '[Site] Add New HearingProtectionType Success',
	AddHearingProtectionTypeFailure = '[Site] Add New HearingProtectionType Failure',
	UpdateHearingProtectionType = '[Site] Update HearingProtectionType',
	UpdateHearingProtectionTypeSuccess = '[Site] Update HearingProtectionType Success',
	UpdateHearingProtectionTypeFailure = '[Site] Update HearingProtectionType Failure',
	DeleteHearingProtectionType = '[Site] Delete HearingProtectionType',
	DeleteHearingProtectionTypeSuccess = '[Site] Delete HearingProtectionType Success',
	DeleteHearingProtectionTypeFailure = '[Site] Delete HearingProtectionType Failure',
	AddInsulationType = '[Site] Add New InsulationType',
	AddInsulationTypeSuccess = '[Site] Add New InsulationType Success',
	AddInsulationTypeFailure = '[Site] Add New InsulationType Failure',
	UpdateInsulationType = '[Site] Update InsulationType',
	UpdateInsulationTypeSuccess = '[Site] Update InsulationType Success',
	UpdateInsulationTypeFailure = '[Site] Update InsulationType Failure',
	DeleteInsulationType = '[Site] Delete InsulationType',
	DeleteInsulationTypeSuccess = '[Site] Delete InsulationType Success',
	DeleteInsulationTypeFailure = '[Site] Delete InsulationType Failure',
	AddIsoNotVerifiedReason = '[Site] Add New IsoNotVerifiedReason',
	AddIsoNotVerifiedReasonSuccess = '[Site] Add New IsoNotVerifiedReason Success',
	AddIsoNotVerifiedReasonFailure = '[Site] Add New IsoNotVerifiedReason Failure',
	UpdateIsoNotVerifiedReason = '[Site] Update IsoNotVerifiedReason',
	UpdateIsoNotVerifiedReasonSuccess = '[Site] Update IsoNotVerifiedReason Success',
	UpdateIsoNotVerifiedReasonFailure = '[Site] Update IsoNotVerifiedReason Failure',
	DeleteIsoNotVerifiedReason = '[Site] Delete IsoNotVerifiedReason',
	DeleteIsoNotVerifiedReasonSuccess = '[Site] Delete IsoNotVerifiedReason Success',
	DeleteIsoNotVerifiedReasonFailure = '[Site] Delete IsoNotVerifiedReason Failure',
	AddStatus = '[Site] Add New Status',
	AddStatusSuccess = '[Site] Add New Status Success',
	AddStatusFailure = '[Site] Add New Status Failure',
	UpdateStatus = '[Site] Update Status',
	UpdateStatusSuccess = '[Site] Update Status Success',
	UpdateStatusFailure = '[Site] Update Status Failure',
	DeleteStatus = '[Site] Delete Status',
	DeleteStatusSuccess = '[Site] Delete Status Success',
	DeleteStatusFailure = '[Site] Delete Status Failure',
	AddTeam = '[Site] Add New Team',
	AddTeamSuccess = '[Site] Add New Team Success',
	AddTeamFailure = '[Site] Add New Team Failure',
	UpdateTeam = '[Site] Update Team',
	UpdateTeamSuccess = '[Site] Update Team Success',
	UpdateTeamFailure = '[Site] Update Team Failure',
	DeleteTeam = '[Site] Delete Team',
	DeleteTeamSuccess = '[Site] Delete Team Success',
	DeleteTeamFailure = '[Site] Delete Team Failure',
	AddVendor = '[Site] Add New Vendor',
	AddVendorSuccess = '[Site] Add New Vendor Success',
	AddVendorFailure = '[Site] Add New Vendor Failure',
	UpdateVendor = '[Site] Update Vendor',
	UpdateVendorSuccess = '[Site] Update Vendor Success',
	UpdateVendorFailure = '[Site] Update Vendor Failure',
	DeleteVendor = '[Site] Delete Vendor',
	DeleteVendorSuccess = '[Site] Delete Vendor Success',
	DeleteVendorFailure = '[Site] Delete Vendor Failure',
}

export class GetSite implements Action {
	readonly type = SiteActionTypes.GetSite;

	constructor(public siteId: string) {}
}

export class GetSiteSuccess implements Action {
	readonly type = SiteActionTypes.GetSiteSuccess;

	constructor(public site: Site) {}
}

export class GetSiteFailure implements Action {
	readonly type = SiteActionTypes.GetSiteFailure;

	constructor(public error: string) {}
}

export class GetSiteNames implements Action {
	readonly type = SiteActionTypes.GetSiteNames;
}

export class GetSiteNamesSuccess implements Action {
	readonly type = SiteActionTypes.GetSiteNamesSuccess;

	constructor(public siteNames: SiteName[]) {}
}

export class GetSiteNamesFailure implements Action {
	readonly type = SiteActionTypes.GetSiteNamesFailure;

	constructor(public error: string) {}
}

export class GetLeakFormDetailsForSite implements Action {
	readonly type = SiteActionTypes.GetLeakFormDetailsForSite;

	constructor(public siteId: string) {}
}

export class GetLeakFormDetailsForSiteSuccess implements Action {
	readonly type = SiteActionTypes.GetLeakFormDetailsForSiteSuccess;

	constructor(public formDetails: LeakFormDetails) {}
}

export class GetLeakFormDetailsForSiteFailure implements Action {
	readonly type = SiteActionTypes.GetLeakFormDetailsForSiteFailure;

	constructor(public error: string) {}
}

export class GetSteamCosts implements Action {
	readonly type = SiteActionTypes.GetSteamCosts;

	constructor(public siteId: string) {}
}

export class GetSteamCostsSuccess implements Action {
	readonly type = SiteActionTypes.GetSteamCostsSuccess;

	constructor(public steamCosts: SteamCost[]) {}
}

export class GetSteamCostsFailure implements Action {
	readonly type = SiteActionTypes.GetSteamCostsFailure;

	constructor(public error: string) {}
}

export class UpdateSteamCosts implements Action {
	readonly type = SiteActionTypes.UpdateSteamCosts;

	constructor(public steamCosts: EditSteamCost[]) {}
}

export class UpdateSteamCostsSuccess implements Action {
	readonly type = SiteActionTypes.UpdateSteamCostsSuccess;

	constructor(public steamCosts: SteamCost[]) {}
}

export class UpdateSteamCostsFailure implements Action {
	readonly type = SiteActionTypes.UpdateSteamCostsFailure;

	constructor(public error: string) {}
}

export class ClearSite implements Action {
	readonly type = SiteActionTypes.ClearSite;

	constructor() {}
}

export class AddFitting implements Action {
	readonly type = SiteActionTypes.AddFitting;

	constructor(public newFitting: NewFitting) {}
}

export class AddFittingSuccess implements Action {
	readonly type = SiteActionTypes.AddFittingSuccess;

	constructor(public fitting: Fitting) {}
}

export class AddFittingFailure implements Action {
	readonly type = SiteActionTypes.AddFittingFailure;

	constructor(public error: string) {}
}

export class UpdateFitting implements Action {
	readonly type = SiteActionTypes.UpdateFitting;

	constructor(public editFitting: EditFitting) {}
}

export class UpdateFittingSuccess implements Action {
	readonly type = SiteActionTypes.UpdateFittingSuccess;

	constructor(public fitting: Fitting) {}
}

export class UpdateFittingFailure implements Action {
	readonly type = SiteActionTypes.UpdateFittingFailure;

	constructor(public error: string) {}
}

export class DeleteFitting implements Action {
	readonly type = SiteActionTypes.DeleteFitting;

	constructor(public fittingId: string) {}
}

export class DeleteFittingSuccess implements Action {
	readonly type = SiteActionTypes.DeleteFittingSuccess;

	constructor(public fittingId: string) {}
}

export class DeleteFittingFailure implements Action {
	readonly type = SiteActionTypes.DeleteFittingFailure;

	constructor(public error: string) {}
}

export class AddFolder implements Action {
	readonly type = SiteActionTypes.AddFolder;

	constructor(public newFolder: NewFolder) {}
}

export class AddFolderSuccess implements Action {
	readonly type = SiteActionTypes.AddFolderSuccess;

	constructor(public folder: Folder) {}
}

export class AddFolderFailure implements Action {
	readonly type = SiteActionTypes.AddFolderFailure;

	constructor(public error: string) {}
}

export class UpdateFolder implements Action {
	readonly type = SiteActionTypes.UpdateFolder;

	constructor(public editFolder: EditFolder) {}
}

export class UpdateFolderSuccess implements Action {
	readonly type = SiteActionTypes.UpdateFolderSuccess;

	constructor(public folder: Folder) {}
}

export class UpdateFolderFailure implements Action {
	readonly type = SiteActionTypes.UpdateFolderFailure;

	constructor(public error: string) {}
}

export class DeleteFolder implements Action {
	readonly type = SiteActionTypes.DeleteFolder;

	constructor(public folderId: string) {}
}

export class DeleteFolderSuccess implements Action {
	readonly type = SiteActionTypes.DeleteFolderSuccess;

	constructor(public folderId: string) {}
}

export class DeleteFolderFailure implements Action {
	readonly type = SiteActionTypes.DeleteFolderFailure;

	constructor(public error: string) {}
}

export class AddHearingProtectionType implements Action {
	readonly type = SiteActionTypes.AddHearingProtectionType;

	constructor(public newHearingProtectionType: NewHearingProtectionType) {}
}

export class AddHearingProtectionTypeSuccess implements Action {
	readonly type = SiteActionTypes.AddHearingProtectionTypeSuccess;

	constructor(public hearingProtectionType: HearingProtectionType) {}
}

export class AddHearingProtectionTypeFailure implements Action {
	readonly type = SiteActionTypes.AddHearingProtectionTypeFailure;

	constructor(public error: string) {}
}

export class UpdateHearingProtectionType implements Action {
	readonly type = SiteActionTypes.UpdateHearingProtectionType;

	constructor(public editHearingProtectionType: EditHearingProtectionType) {}
}

export class UpdateHearingProtectionTypeSuccess implements Action {
	readonly type = SiteActionTypes.UpdateHearingProtectionTypeSuccess;

	constructor(public hearingProtectionType: HearingProtectionType) {}
}

export class UpdateHearingProtectionTypeFailure implements Action {
	readonly type = SiteActionTypes.UpdateHearingProtectionTypeFailure;

	constructor(public error: string) {}
}

export class DeleteHearingProtectionType implements Action {
	readonly type = SiteActionTypes.DeleteHearingProtectionType;

	constructor(public hearingProtectionTypeId: string) {}
}

export class DeleteHearingProtectionTypeSuccess implements Action {
	readonly type = SiteActionTypes.DeleteHearingProtectionTypeSuccess;

	constructor(public hearingProtectionTypeId: string) {}
}

export class DeleteHearingProtectionTypeFailure implements Action {
	readonly type = SiteActionTypes.DeleteHearingProtectionTypeFailure;

	constructor(public error: string) {}
}

export class AddInsulationType implements Action {
	readonly type = SiteActionTypes.AddInsulationType;

	constructor(public newInsulationType: NewInsulationType) {}
}

export class AddInsulationTypeSuccess implements Action {
	readonly type = SiteActionTypes.AddInsulationTypeSuccess;

	constructor(public insulationType: InsulationType) {}
}

export class AddInsulationTypeFailure implements Action {
	readonly type = SiteActionTypes.AddInsulationTypeFailure;

	constructor(public error: string) {}
}

export class UpdateInsulationType implements Action {
	readonly type = SiteActionTypes.UpdateInsulationType;

	constructor(public editInsulationType: EditInsulationType) {}
}

export class UpdateInsulationTypeSuccess implements Action {
	readonly type = SiteActionTypes.UpdateInsulationTypeSuccess;

	constructor(public insulationType: InsulationType) {}
}

export class UpdateInsulationTypeFailure implements Action {
	readonly type = SiteActionTypes.UpdateInsulationTypeFailure;

	constructor(public error: string) {}
}

export class DeleteInsulationType implements Action {
	readonly type = SiteActionTypes.DeleteInsulationType;

	constructor(public insulationTypeId: string) {}
}

export class DeleteInsulationTypeSuccess implements Action {
	readonly type = SiteActionTypes.DeleteInsulationTypeSuccess;

	constructor(public insulationTypeId: string) {}
}

export class DeleteInsulationTypeFailure implements Action {
	readonly type = SiteActionTypes.DeleteInsulationTypeFailure;

	constructor(public error: string) {}
}

export class AddIsoNotVerifiedReason implements Action {
	readonly type = SiteActionTypes.AddIsoNotVerifiedReason;

	constructor(public newIsoNotVerifiedReason: NewIsoNotVerifiedReason) {}
}

export class AddIsoNotVerifiedReasonSuccess implements Action {
	readonly type = SiteActionTypes.AddIsoNotVerifiedReasonSuccess;

	constructor(public isoNotVerifiedReason: IsolationNotVerifiedReason) {}
}

export class AddIsoNotVerifiedReasonFailure implements Action {
	readonly type = SiteActionTypes.AddIsoNotVerifiedReasonFailure;

	constructor(public error: string) {}
}

export class UpdateIsoNotVerifiedReason implements Action {
	readonly type = SiteActionTypes.UpdateIsoNotVerifiedReason;

	constructor(public editIsoNotVerifiedReason: EditIsoNotVerifiedReason) {}
}

export class UpdateIsoNotVerifiedReasonSuccess implements Action {
	readonly type = SiteActionTypes.UpdateIsoNotVerifiedReasonSuccess;

	constructor(public isoNotVerifiedReason: IsolationNotVerifiedReason) {}
}

export class UpdateIsoNotVerifiedReasonFailure implements Action {
	readonly type = SiteActionTypes.UpdateIsoNotVerifiedReasonFailure;

	constructor(public error: string) {}
}

export class DeleteIsoNotVerifiedReason implements Action {
	readonly type = SiteActionTypes.DeleteIsoNotVerifiedReason;

	constructor(public isoNotVerifiedReasonId: string) {}
}

export class DeleteIsoNotVerifiedReasonSuccess implements Action {
	readonly type = SiteActionTypes.DeleteIsoNotVerifiedReasonSuccess;

	constructor(public isoNotVerifiedReasonId: string) {}
}

export class DeleteIsoNotVerifiedReasonFailure implements Action {
	readonly type = SiteActionTypes.DeleteIsoNotVerifiedReasonFailure;

	constructor(public error: string) {}
}

export class AddStatus implements Action {
	readonly type = SiteActionTypes.AddStatus;

	constructor(public newStatus: NewStatus) {}
}

export class AddStatusSuccess implements Action {
	readonly type = SiteActionTypes.AddStatusSuccess;

	constructor(public status: LeakStatus) {}
}

export class AddStatusFailure implements Action {
	readonly type = SiteActionTypes.AddStatusFailure;

	constructor(public error: string) {}
}

export class UpdateStatus implements Action {
	readonly type = SiteActionTypes.UpdateStatus;

	constructor(public editStatus: EditStatus) {}
}

export class UpdateStatusSuccess implements Action {
	readonly type = SiteActionTypes.UpdateStatusSuccess;

	constructor(public status: LeakStatus) {}
}

export class UpdateStatusFailure implements Action {
	readonly type = SiteActionTypes.UpdateStatusFailure;

	constructor(public error: string) {}
}

export class DeleteStatus implements Action {
	readonly type = SiteActionTypes.DeleteStatus;

	constructor(public statusId: string) {}
}

export class DeleteStatusSuccess implements Action {
	readonly type = SiteActionTypes.DeleteStatusSuccess;

	constructor(public statusId: string) {}
}

export class DeleteStatusFailure implements Action {
	readonly type = SiteActionTypes.DeleteStatusFailure;

	constructor(public error: string) {}
}

export class AddTeam implements Action {
	readonly type = SiteActionTypes.AddTeam;

	constructor(public newTeam: NewTeam) {}
}

export class AddTeamSuccess implements Action {
	readonly type = SiteActionTypes.AddTeamSuccess;

	constructor(public team: Team) {}
}

export class AddTeamFailure implements Action {
	readonly type = SiteActionTypes.AddTeamFailure;

	constructor(public error: string) {}
}

export class UpdateTeam implements Action {
	readonly type = SiteActionTypes.UpdateTeam;

	constructor(public editTeam: EditTeam) {}
}

export class UpdateTeamSuccess implements Action {
	readonly type = SiteActionTypes.UpdateTeamSuccess;

	constructor(public team: Team) {}
}

export class UpdateTeamFailure implements Action {
	readonly type = SiteActionTypes.UpdateTeamFailure;

	constructor(public error: string) {}
}

export class DeleteTeam implements Action {
	readonly type = SiteActionTypes.DeleteTeam;

	constructor(public teamId: string) {}
}

export class DeleteTeamSuccess implements Action {
	readonly type = SiteActionTypes.DeleteTeamSuccess;

	constructor(public teamId: string) {}
}

export class DeleteTeamFailure implements Action {
	readonly type = SiteActionTypes.DeleteTeamFailure;

	constructor(public error: string) {}
}

export class AddVendor implements Action {
	readonly type = SiteActionTypes.AddVendor;

	constructor(public newVendor: NewVendor) {}
}

export class AddVendorSuccess implements Action {
	readonly type = SiteActionTypes.AddVendorSuccess;

	constructor(public vendor: Vendor) {}
}

export class AddVendorFailure implements Action {
	readonly type = SiteActionTypes.AddVendorFailure;

	constructor(public error: string) {}
}

export class UpdateVendor implements Action {
	readonly type = SiteActionTypes.UpdateVendor;

	constructor(public editVendor: EditVendor) {}
}

export class UpdateVendorSuccess implements Action {
	readonly type = SiteActionTypes.UpdateVendorSuccess;

	constructor(public vendor: Vendor) {}
}

export class UpdateVendorFailure implements Action {
	readonly type = SiteActionTypes.UpdateVendorFailure;

	constructor(public error: string) {}
}

export class DeleteVendor implements Action {
	readonly type = SiteActionTypes.DeleteVendor;

	constructor(public vendorId: string) {}
}

export class DeleteVendorSuccess implements Action {
	readonly type = SiteActionTypes.DeleteVendorSuccess;

	constructor(public vendorId: string) {}
}

export class DeleteVendorFailure implements Action {
	readonly type = SiteActionTypes.DeleteVendorFailure;

	constructor(public error: string) {}
}

export type SiteActionsUnion =
	| GetSite
	| GetSiteSuccess
	| GetSiteFailure
	| GetSiteNames
	| GetSiteNamesSuccess
	| GetSiteNamesFailure
	| GetLeakFormDetailsForSite
	| GetLeakFormDetailsForSiteSuccess
	| GetLeakFormDetailsForSiteFailure
	| GetSteamCosts
	| GetSteamCostsSuccess
	| GetSteamCostsFailure
	| UpdateSteamCosts
	| UpdateSteamCostsSuccess
	| UpdateSteamCostsFailure
	| AddFitting
	| AddFittingSuccess
	| AddFittingFailure
	| UpdateFitting
	| UpdateFittingSuccess
	| UpdateFittingFailure
	| DeleteFitting
	| DeleteFittingSuccess
	| DeleteFittingFailure
	| AddFolder
	| AddFolderSuccess
	| AddFolderFailure
	| UpdateFolder
	| UpdateFolderSuccess
	| UpdateFolderFailure
	| DeleteFolder
	| DeleteFolderSuccess
	| DeleteFolderFailure
	| AddHearingProtectionType
	| AddHearingProtectionTypeSuccess
	| AddHearingProtectionTypeFailure
	| UpdateHearingProtectionType
	| UpdateHearingProtectionTypeSuccess
	| UpdateHearingProtectionTypeFailure
	| DeleteHearingProtectionType
	| DeleteHearingProtectionTypeSuccess
	| DeleteHearingProtectionTypeFailure
	| AddInsulationType
	| AddInsulationTypeSuccess
	| AddInsulationTypeFailure
	| UpdateInsulationType
	| UpdateInsulationTypeSuccess
	| UpdateInsulationTypeFailure
	| DeleteInsulationType
	| DeleteInsulationTypeSuccess
	| DeleteInsulationTypeFailure
	| AddIsoNotVerifiedReason
	| AddIsoNotVerifiedReasonSuccess
	| AddIsoNotVerifiedReasonFailure
	| UpdateIsoNotVerifiedReason
	| UpdateIsoNotVerifiedReasonSuccess
	| UpdateIsoNotVerifiedReasonFailure
	| DeleteIsoNotVerifiedReason
	| DeleteIsoNotVerifiedReasonSuccess
	| DeleteIsoNotVerifiedReasonFailure
	| AddStatus
	| AddStatusSuccess
	| AddStatusFailure
	| UpdateStatus
	| UpdateStatusSuccess
	| UpdateStatusFailure
	| DeleteStatus
	| DeleteStatusSuccess
	| DeleteStatusFailure
	| AddTeam
	| AddTeamSuccess
	| AddTeamFailure
	| UpdateTeam
	| UpdateTeamSuccess
	| UpdateTeamFailure
	| DeleteTeam
	| DeleteTeamSuccess
	| DeleteTeamFailure
	| AddVendor
	| AddVendorSuccess
	| AddVendorFailure
	| UpdateVendor
	| UpdateVendorSuccess
	| UpdateVendorFailure
	| DeleteVendor
	| DeleteVendorSuccess
	| DeleteVendorFailure
	| ClearSite;
